import React from 'react';
import PropTypes from 'prop-types';

import Cat from './Cat';
import LilDoggo from './LilDoggo';
import ClassicDoggo from './ClassicDoggo';
import TuxedoBird from './TuxedoBird';
import Tiger from './Tiger';
import Leopard from './Leopard';
import Bear from './Bear';
import Tortoise from './Tortoise';
import Chicken from './Chicken';
import Seal from './Seal';
import Bunny from './Bunny';
import Pig from './Pig';
import ComingSoon from './ComingSoon';

const Pets = {
  Cat,
  LilDoggo,
  ClassicDoggo,
  TuxedoBird,
  ComingSoon,
  Tiger,
  Leopard,
  Bear,
  Tortoise,
  Chicken,
  Seal,
  Bunny,
  Pig,
};

function Pet(props) {
  const ThisPet = Pets[props.petType.name];
  return <ThisPet {...props} />;
}

Pet.propTypes = {
  petType: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
  }),
};

Pet.defaultProps = {
  petType: {
    sku: 'cat_tabbycat',
    type: 'cat',
    name: 'Cat',
  },
};

export default Pet;



// WEBPACK FOOTER //
// ./src/components/Global/Pet/index.js